<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>系统功能</el-breadcrumb-item>
          <el-breadcrumb-item>编辑导航菜单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="info">
            <div class="tab-content">
              <el-form
                ref="editForm"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
                label-width="120px"
              >
                <el-form-item label="所属父级">
                  <cn-dropdown-select
                    v-model="model.parentId"
                    :disabled="model.id"
                    :data="navListData"
                    placeholder="请选择"
                  >
                  </cn-dropdown-select>
                </el-form-item>
                <el-form-item label="所属频道">
                  <el-select v-model="model.channelId" placeholder="请选择...">
                    <el-option
                      key="0"
                      label="不属于频道"
                      :value="0"
                      v-if="model.id > 0"
                    ></el-option>
                    <el-option
                      v-for="(item, index) in channelListData"
                      :key="index"
                      :label="item.title"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="name" label="菜单标识">
                  <el-input
                    v-model="model.name"
                    placeholder="必填，只允许英文下划线"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="title" label="显示标题">
                  <el-input
                    v-model="model.title"
                    placeholder="必填，128字符内"
                  ></el-input>
                </el-form-item>
                <el-form-item label="副标题">
                  <el-input
                    v-model="model.subTitle"
                    placeholder="可空，128字符内"
                  ></el-input>
                </el-form-item>
                <el-form-item label="图标样式">
                  <el-input
                    v-model="model.iconUrl"
                    placeholder="以.开头的CSS样式，不填则默认"
                  ></el-input>
                </el-form-item>
                <el-form-item label="链接地址">
                  <el-input
                    v-model="model.linkUrl"
                    placeholder="可空，512字符内"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="sortId" label="排序数字">
                  <el-input
                    v-model="model.sortId"
                    placeholder="数字越小越排前"
                  ></el-input>
                </el-form-item>
                <el-form-item label="控制器名称">
                  <el-input
                    v-model="model.controller"
                    placeholder="必填，API权限控制器名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="权限资源">
                  <el-input
                    v-model="model.resource"
                    placeholder="必填，例如:Show,View,Add"
                  ></el-input>
                </el-form-item>
                <el-form-item label="备注说明">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="model.remark"
                    placeholder="可空，500字符内"
                  ></el-input>
                </el-form-item>
                <el-form-item label="是否显示">
                  <el-switch
                    :active-value="0"
                    :inactive-value="1"
                    v-model="model.status"
                  ></el-switch>
                </el-form-item>
                <el-form-item label="系统菜单">
                  <el-switch
                    :active-value="1"
                    :inactive-value="0"
                    v-model="model.isSystem"
                  ></el-switch>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm">确认保存</el-button>
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../js/tree.component.js";
import { AxiosAjax } from "../../js/axios.config";
export default {
  data() {
    return {
      activeName: "info", //当前选项卡
      labelPosition: "right", //表单对齐方式
      navListData: [],
      channelListData: [],
      model: {
        id: "0",
        classLayer: 0,
        addBy: null,
        addTime: null,
        parentId: "0",
        channelId: null,
        name: null,
        title: null,
        subTitle: null,
        iconUrl: null,
        linkUrl: null,
        sortId: 99,
        status: 0,
        isSystem: 0,
        remark: null,
        controller: null,
        resource: null,
      },
      rules: {
        name: [
          { required: true, message: "请输入导航菜单名称", trigger: "blur" },
          {
            min: 2,
            max: 128,
            message: "长度在 2 到 128 个字符",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z_]{1,}$/,
            message: "只能字母和下划线",
            trigger: "blur",
          },
        ],
        title: [
          { required: true, message: "请输入导航菜单标题", trigger: "blur" },
        ],
        sortId: [
          { required: true, message: "请输入排序数字", trigger: "blur" },
          {
            pattern: /^[+]{0,1}(\d+)$/,
            message: "只能为正整数",
            trigger: "blur",
          },
        ],
        controller: [
          { required: true, message: "请填写API控制器名称", trigger: "blur" },
        ],
        resource: [
          {
            required: true,
            message: "请填写权限资源,以逗号分开",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    //初始化数据
    initData: function () {
      let _this = this; //当前页面
      let id = _this.$route.query.id || ""; //获取ID
      let parentId = _this.$route.query.parentId || ""; //获取父ID
      if (id) {
        AxiosAjax({
          url: "/cabinet/navigation/" + id,
          loading: true,
          success: function (res) {
            //赋值给model
            Object.keys(_this.model).forEach((key) => {
              _this.model[key] = res.data.data[key];
            });
          },
        });
      } else if (parentId) {
        _this.model.parentId = parentId;
      }
      //加载菜单列表
      AxiosAjax({
        // url: '/cabinet/navigation/getList',
        url: "/cabinet/navigation/v2/getList",
        loading: true,
        success: function (res) {
          _this.navListData = res.data.data;
          console.log(" _this.navListData", _this.navListData);
        },
      });
      // //加载频道列表
      // AxiosAjax({
      //    url: '/channel',
      //    loading: true,
      //    success: function (res) {
      //        _this.channelListData = res.data
      //    }
      // });
    },
    submitForm: function () {
      let _this = this; //当前页面
      //多个表单验证
      const f1 = new Promise((resolve, reject) => {
        _this.$refs["editForm"].validate((valid) => {
          if (valid) resolve();
        });
      });
      Promise.all([f1]).then(() => {
        //如果是数组则取最后一个值
        if (Array.isArray(_this.model.parentId)) {
          _this.model.parentId =
            _this.model.parentId[_this.model.parentId.length - 1];
        }
        //提交表单,Id大于0则修改，否则添加
        if (_this.model.id > 0) {
          AxiosAjax({
            method: "post",
            url: "/cabinet/navigation/update",
            data: _this.model,
            loading: true,
            successMsg: "修改导航菜单已成功",
            success: function (res) {
              //可跳转加列表页
              if (parent.vm) parent.vm.initData(); //重新加载菜单
              _this.$router.push({ name: "NavList" });
            },
          });
        } else {
          AxiosAjax({
            method: "post",
            // url: '/cabinet/navigation/save',
            url: "/cabinet/navigation/v2/save",
            data: _this.model,
            loading: true,
            successMsg: "新增导航菜单已成功",
            success: function (res) {
              //重置表单
              _this.$refs["editForm"].resetFields();
              if (parent.vm) parent.vm.initData(); //重新加载菜单
            },
          });
        }
      });
    },
    resetForm() {
      window.history.back(-1);
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Setting/NavEdit.vue